import { createIcon } from "app/icons/createIcon";
import _AdultFilledIcon from "./AdultFilledIcon";
import _AdultStrokeIcon from "./AdultStrokeIcon";
import _AgreementFilledIcon from "./AgreementFilledIcon";
import _AgreementStrokeIcon from "./AgreementStrokeIcon";
import _AiMessageFilledIcon from "./AiMessageFilledIcon";
import _AiMessageStrokeIcon from "./AiMessageStrokeIcon";
import _BabyFilledIcon from "./BabyFilledIcon";
import _BabyStrokeIcon from "./BabyStrokeIcon";
import _CallCircleFilledIcon from "./CallCircleFilledIcon";
import _CallCircleStrokeIcon from "./CallCircleStrokeIcon";
import _CallFilledIcon from "./CallFilledIcon";
import _CallStrokeIcon from "./CallStrokeIcon";
import _ChatFilledIcon from "./ChatFilledIcon";
import _ChatStrokeIcon from "./ChatStrokeIcon";
import _ChildFilledIcon from "./ChildFilledIcon";
import _ChildStrokeIcon from "./ChildStrokeIcon";
import _IdeaFilledIcon from "./IdeaFilledIcon";
import _IdeaStrokeIcon from "./IdeaStrokeIcon";
import _MailFilledIcon from "./MailFilledIcon";
import _MailStrokeIcon from "./MailStrokeIcon";
import _MaskFilledIcon from "./MaskFilledIcon";
import _MaskStrokeIcon from "./MaskStrokeIcon";
import _MultiUserFilledIcon from "./MultiUserFilledIcon";
import _MultiUserStrokeIcon from "./MultiUserStrokeIcon";
import _SecurityCheckFilledIcon from "./SecurityCheckFilledIcon";
import _SecurityCheckStrokeIcon from "./SecurityCheckStrokeIcon";
import _SendMessageFilledIcon from "./SendMessageFilledIcon";
import _SendMessageStrokeIcon from "./SendMessageStrokeIcon";
import _ShieldEuroFilledIcon from "./ShieldEuroFilledIcon";
import _ShieldEuroStrokeIcon from "./ShieldEuroStrokeIcon";
import _ShieldHealthFilledIcon from "./ShieldHealthFilledIcon";
import _ShieldHealthStrokeIcon from "./ShieldHealthStrokeIcon";
import _ShieldSunFilledIcon from "./ShieldSunFilledIcon";
import _ShieldSunStrokeIcon from "./ShieldSunStrokeIcon";
import _SimpleUserFilledIcon from "./SimpleUserFilledIcon";
import _SimpleUserStrokeIcon from "./SimpleUserStrokeIcon";
import _SupportFilledIcon from "./SupportFilledIcon";
import _SupportStrokeIcon from "./SupportStrokeIcon";
import _UserCircleFilledIcon from "./UserCircleFilledIcon";
import _UserCircleSolidIcon from "./UserCircleSolidIcon";
import _UserCircleStrokeIcon from "./UserCircleStrokeIcon";
import _UserLockIcon from "./UserLockIcon";
import _UserLoveFilledIcon from "./UserLoveFilledIcon";
import _UserLoveStrokeIcon from "./UserLoveStrokeIcon";

export const AdultFilledIcon = createIcon(_AdultFilledIcon);
export const AdultStrokeIcon = createIcon(_AdultStrokeIcon);
export const AgreementFilledIcon = createIcon(_AgreementFilledIcon);
export const AgreementStrokeIcon = createIcon(_AgreementStrokeIcon);
export const AiMessageFilledIcon = createIcon(_AiMessageFilledIcon);
export const AiMessageStrokeIcon = createIcon(_AiMessageStrokeIcon);
export const BabyFilledIcon = createIcon(_BabyFilledIcon);
export const BabyStrokeIcon = createIcon(_BabyStrokeIcon);
export const CallCircleFilledIcon = createIcon(_CallCircleFilledIcon);
export const CallCircleStrokeIcon = createIcon(_CallCircleStrokeIcon);
export const CallFilledIcon = createIcon(_CallFilledIcon);
export const CallStrokeIcon = createIcon(_CallStrokeIcon);
export const ChatFilledIcon = createIcon(_ChatFilledIcon);
export const ChatStrokeIcon = createIcon(_ChatStrokeIcon);
export const ChildFilledIcon = createIcon(_ChildFilledIcon);
export const ChildStrokeIcon = createIcon(_ChildStrokeIcon);
export const IdeaFilledIcon = createIcon(_IdeaFilledIcon);
export const IdeaStrokeIcon = createIcon(_IdeaStrokeIcon);
export const MailFilledIcon = createIcon(_MailFilledIcon);
export const MailStrokeIcon = createIcon(_MailStrokeIcon);
export const MaskFilledIcon = createIcon(_MaskFilledIcon);
export const MaskStrokeIcon = createIcon(_MaskStrokeIcon);
export const MultiUserFilledIcon = createIcon(_MultiUserFilledIcon);
export const MultiUserStrokeIcon = createIcon(_MultiUserStrokeIcon);
export const SecurityCheckFilledIcon = createIcon(_SecurityCheckFilledIcon);
export const SecurityCheckStrokeIcon = createIcon(_SecurityCheckStrokeIcon);
export const SendMessageFilledIcon = createIcon(_SendMessageFilledIcon);
export const SendMessageStrokeIcon = createIcon(_SendMessageStrokeIcon);
export const ShieldEuroFilledIcon = createIcon(_ShieldEuroFilledIcon);
export const ShieldEuroStrokeIcon = createIcon(_ShieldEuroStrokeIcon);
export const ShieldHealthFilledIcon = createIcon(_ShieldHealthFilledIcon);
export const ShieldHealthStrokeIcon = createIcon(_ShieldHealthStrokeIcon);
export const ShieldSunFilledIcon = createIcon(_ShieldSunFilledIcon);
export const ShieldSunStrokeIcon = createIcon(_ShieldSunStrokeIcon);
export const SimpleUserFilledIcon = createIcon(_SimpleUserFilledIcon);
export const SimpleUserStrokeIcon = createIcon(_SimpleUserStrokeIcon);
export const SupportFilledIcon = createIcon(_SupportFilledIcon);
export const SupportStrokeIcon = createIcon(_SupportStrokeIcon);
export const UserCircleFilledIcon = createIcon(_UserCircleFilledIcon);
export const UserCircleSolidIcon = createIcon(_UserCircleSolidIcon);
export const UserCircleStrokeIcon = createIcon(_UserCircleStrokeIcon);
export const UserLockIcon = createIcon(_UserLockIcon);
export const UserLoveFilledIcon = createIcon(_UserLoveFilledIcon);
export const UserLoveStrokeIcon = createIcon(_UserLoveStrokeIcon);
